import { Injectable } from '@angular/core';
import { OpeningBalanceService } from '@app/core/Services';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { tap } from 'rxjs/operators';
import {
  GetFundOpeningBalance,
  GetFundOpeningBalanceBasedOnAPId,
  GetFundOpeningBalanceBasedOnAPIdAndJournalId,
  GetOpeningBalanceBasedOnAPId,
  GetOpeningBalanceList,
  SaveOpeningBalance,
  SaveOpeningBalanceExplain,
  SaveOpeningBalanceFundExplain,
  SaveOpeningBalanceFundExplainBasedOnAPId,
  SaveOpeningBalanceFundExplainBasedOnAPIdAndJournalId,
  SaveTrialBalance,
} from './opening-balance.action';

export class OpeningBalanceStateInfo {
  openingBalanceData: any;
  openingBalanceFundExplainData: Array<any>;
  openingBalanceBasedOnDate: any;
  isOpeningBalance: boolean;
  isTrialBalance: boolean;
  isOpeningBalanceExplain: boolean;
}

@State<OpeningBalanceStateInfo>({
  name: 'openingBalance',
  defaults: {
    openingBalanceData: [],
    openingBalanceFundExplainData: [],
    openingBalanceBasedOnDate: [],
    isOpeningBalance: false,
    isTrialBalance: false,
    isOpeningBalanceExplain: false,
  },
})
@Injectable()
export class OpeningBalanceState {
  constructor(private openingBalanceService: OpeningBalanceService) {}
  @Selector()
  static getJournalAccounts(state: OpeningBalanceStateInfo) {
    return state.openingBalanceData;
  }
  @Action(SaveOpeningBalance)
  saveOpeningBalance(
    { patchState }: StateContext<OpeningBalanceStateInfo>,
    action: SaveOpeningBalance
  ) {
    return this.openingBalanceService
      .saveOpeningBalance(action.openingBalance)
      .pipe(
        tap((res) => {
          patchState({
            isOpeningBalance: res,
          });
        })
      );
  }

  @Action(SaveTrialBalance)
  saveTrialBalance(
    { patchState }: StateContext<OpeningBalanceStateInfo>,
    action: SaveTrialBalance
  ) {
    return this.openingBalanceService
      .saveTrialBalance(action.trialBalance)
      .pipe(
        tap((res) => {
          patchState({
            isTrialBalance: res,
          });
        })
      );
  }

  @Action(SaveOpeningBalanceFundExplain)
  saveOpeningBalanceFundExplain(
    { patchState }: StateContext<OpeningBalanceStateInfo>,
    action: SaveOpeningBalanceFundExplain
  ) {
    return this.openingBalanceService
      .saveOpeningBalanceFundExplain(action.openingBalanceFundExplain)
      .pipe(
        tap((res) => {
          patchState({
            isOpeningBalanceExplain: res,
          });
        })
      );
  }

  @Action(SaveOpeningBalanceExplain)
  saveOpeningBalanceExplain(
    { patchState }: StateContext<OpeningBalanceStateInfo>,
    action: SaveOpeningBalanceExplain
  ) {
    return this.openingBalanceService
      .saveOpeningBalanceExplain(
        action.openingBalanceExplain,
        action.accountTypeId
      )
      .pipe(
        tap((res) => {
          patchState({
            isOpeningBalanceExplain: res,
          });
        })
      );
  }

  @Action(GetOpeningBalanceList)
  getOpeningBalanceList(
    { getState, patchState }: StateContext<OpeningBalanceStateInfo>,
    action: GetOpeningBalanceList
  ) {
    return this.openingBalanceService.getOpeningBalanceList().pipe(
      tap((res) => {
        patchState({
          openingBalanceData: res,
        });
      })
    );
  }

  @Action(GetOpeningBalanceBasedOnAPId)
  getOpeningBalanceBasedOnAPId(
    { getState, patchState }: StateContext<OpeningBalanceStateInfo>,
    action: GetOpeningBalanceBasedOnAPId
  ) {
    return this.openingBalanceService
      .getOpeningBalanceBasedOnAPId(action.accoutingPeriodId)
      .pipe(
        tap((res) => {
          patchState({
            openingBalanceData: res,
          });
        })
      );
  }

  @Action(GetFundOpeningBalance)
  getFundOpeningBalance(
    { patchState }: StateContext<OpeningBalanceStateInfo>,
    action: GetFundOpeningBalance
  ) {
    return this.openingBalanceService.getFundOpeningBalance().pipe(
      tap((res) => {
        patchState({
          openingBalanceFundExplainData: res,
        });
      })
    );
  }

  @Action(GetFundOpeningBalanceBasedOnAPId)
  getFundOpeningBalanceBasedOnAPId(
    { patchState }: StateContext<OpeningBalanceStateInfo>,
    action: GetFundOpeningBalanceBasedOnAPId
  ) {
    return this.openingBalanceService
      .getFundOpeningBalanceBasedOnAPId(action.accoutingPeriodId)
      .pipe(
        tap((res) => {
          patchState({
            openingBalanceFundExplainData: res,
          });
        })
      );
  }

  @Action(SaveOpeningBalanceFundExplainBasedOnAPId)
  saveOpeningBalanceFundExplainBasedOnAPId(
    { patchState }: StateContext<OpeningBalanceStateInfo>,
    action: SaveOpeningBalanceFundExplainBasedOnAPId
  ) {
    return this.openingBalanceService
      .saveOpeningBalanceFundExplainBasedOnAPId(
        action.openingBalanceFundExplain,
        action.accountingPeriodId
      )
      .pipe(
        tap((res) => {
          patchState({
            isOpeningBalanceExplain: res,
          });
        })
      );
  }

  @Action(GetFundOpeningBalanceBasedOnAPIdAndJournalId)
  getFundOpeningBalanceBasedOnAPIdAndJournalId(
    { patchState }: StateContext<OpeningBalanceStateInfo>,
    action: GetFundOpeningBalanceBasedOnAPIdAndJournalId
  ) {
    return this.openingBalanceService
      .getFundOpeningBalanceBasedOnAPIdAndJournalId(action.accoutingPeriodId,action.jouranlId)
      .pipe(
        tap((res) => {
          patchState({
            openingBalanceFundExplainData: res,
          });
        })
      );
  }

  @Action(SaveOpeningBalanceFundExplainBasedOnAPIdAndJournalId)
  saveOpeningBalanceFundExplainBasedOnAPIdAndJournalId(
    { patchState }: StateContext<OpeningBalanceStateInfo>,
    action: SaveOpeningBalanceFundExplainBasedOnAPIdAndJournalId
    
  ) {
    return this.openingBalanceService
      .saveOpeningBalanceFundExplainBasedOnAPIdAndJournalId(
        action.openingBalanceFundExplain,
        action.accountingPeriodId,
        action.journalId
      )
      .pipe(
        tap((res) => {
          patchState({
            isOpeningBalanceExplain: res,
          });
        })
      );
  }
}
